/**
 * @Description Reducer for manual commission records
 * @FileName manualCommissionRecords.js
 * @Author Karthick - kkarthk
 * @CreatedOn 04 Oct, 2022 04:15:36
 * @IssueID - Issue IDs
 */
import { mcrDetailActionTypes } from '../actions/actionTypes';
import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';

const initialStateExt = {
  approveRequest: null,
  approveRequestError: null,
  approveRequestedOn: null,
  approveRequestProcessedOn: null,
  approveData: null,
  detailLastImpData: null,
  getEditItemDetails: null,
};

const ManualCommissionRecords = (state = { ...basicListAddEditDltInitialState, ...initialStateExt }, action = null) => {
  switch (action.type) {
    case mcrDetailActionTypes.IMPORT_MCR_RESPONSE:
      return {
        ...state,
        detailData: action.data.detailData,
      };
    case mcrDetailActionTypes.RESET_UPSERT_ERROR:
      return {
        ...state,
        upsertRequestError: [],
      };
    case mcrDetailActionTypes.SET_MCR_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case mcrDetailActionTypes.RESET_UPSERT_VALUE:
      return {
        ...state,
        upsertRequest: action.data.upsertRequest,
        upsertRequestError: action.data.upsertRequestError,
        upsertRequestedOn: action.data.upsertRequestedOn,
        upsertRequestProcessedOn: action.data.upsertRequestProcessedOn,
        upsertData: action.data.upsertData,
        loading: false,
      };
    case mcrDetailActionTypes.RESET_DELETE_MCR_VALUE:
      return {
        ...state,
        deleteRequest: action.data.deleteRequest,
        deleteRequestError: action.data.deleteRequestError,
        deleteRequestedOn: action.data.deleteRequestedOn,
        deleteRequestProcessedOn: action.data.deleteRequestProcessedOn,
        deleteData: action.data.deleteData,
      };
    case mcrDetailActionTypes.RESET_APPROVE_MCR_VALUE:
      return {
        ...state,
        approveRequest: action.data.approveRequest,
        approveRequestError: action.data.approveRequestError,
        approveRequestedOn: action.data.approveRequestedOn,
        approveRequestProcessedOn: action.data.approveRequestProcessedOn,
        approveData: action.data.approveData,
      };
    case mcrDetailActionTypes.RESET_IMPORT_MCR:
      return {
        ...state,
        detailData: action.data.detailData,
        detailRequest: action.data.detailRequest,
        detailRequestError: action.data.detailRequestError,
        detailRequestedOn: action.data.detailRequestedOn,
        detailRequestProcessedOn: action.data.detailRequestProcessedOn,
        detailLastImpData: action.data.detailLastImpData,
      };
    case mcrDetailActionTypes.UPSERT_MCR_REQUEST:
      return {
        ...state,
        upsertRequestedOn: new Date(),
        upsertData: action.data.upsertData,
        loading: true,
      };
    case commonTypes.RESETSTORE:
      return basicListAddEditDltInitialState;
    default:
      return state;
  }
};

export default ManualCommissionRecords;
